import React from 'react';
import { MenuTwo } from './menu-two/MenuTwo';

export const rotor = props => ({
  menuTwo: <MenuTwo {...props} />,
});
